// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { IndicesDataAppModule } from './app.module';
bootstrapAppModule(IndicesDataAppModule);
